import { render, staticRenderFns } from "./ItemsGrid.component.vue?vue&type=template&id=2e9e6faa&scoped=true"
import script from "./ItemsGrid.component.vue?vue&type=script&lang=js"
export * from "./ItemsGrid.component.vue?vue&type=script&lang=js"
import style0 from "./ItemsGrid.component.vue?vue&type=style&index=0&id=2e9e6faa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9e6faa",
  null
  
)

export default component.exports